import React, {Component} from 'react';
import { Table } from 'semantic-ui-react'
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'
import LocalNumber from '../LocalNumber'
import {client} from '../../Client';
import Moment from 'moment';

class ReportMovimentiView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: this.props.items,
            rows: [],
            ultimaModificaInfo: {},
            totali: null,
            tableRows: null

        };
        this.loadData = this.loadData.bind(this)
    }

    componentDidMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.items && nextProps.items && this.state.items.length !== nextProps.items.length){
            this.setState({items: nextProps.items}, ()=>{
                this.loadData();
            });
        }
    }

    loadData(){
        //console.log("ITEMS:", this.state.items); vengono dalla tabella
        let rows =[];
        let items = this.state.items;
        if (items === undefined || items.length <= 0 ){
            if (this.props.onDataCompleted) {
                this.props.onDataCompleted({type:'PDC',title:'Report movimenti per PDC',rows});
            }
            return;
        }
        // Crea le righe
        let ultimaModificaInfo = {}
        let totali = {
            'E': {
                impCategoria:0,
                totCategoria:0,
                impVoce:0,
                totVoce:0,
                impSottovoce:0,
                totSottovoce:0,
                imp:0,
                tot:0,
            },
            'U': {
                impCategoria:0,
                totCategoria:0,
                impVoce:0,
                totVoce:0,
                impSottovoce:0,
                totSottovoce:0,
                imp:0,
                tot:0,
            },
        };


        let tableRows = [];
        let i = 0;
        let categoria = null;
        let voce = null;
        let sottovoce = null;
        if (items.length > 0){
            this.ordinaMovimenti(items);
            items.forEach((item) => {

                if (item.modificatoIl && (ultimaModificaInfo.modificatoIl === undefined || ultimaModificaInfo.modificatoIl <= item.modificatoIl ))
                {
                    ultimaModificaInfo.modificatoIl = item.modificatoIl;
                    ultimaModificaInfo.modificatoDa = item.modificatoDa;
                }

                let tabEntrCorrispettivo = <Table.Cell  textAlign='right'></Table.Cell>;
                let tabEntrPagamento = <Table.Cell  textAlign='right'></Table.Cell>;
                let tabUscCorrispettivo = <Table.Cell  textAlign='right'></Table.Cell>;
                let tabUscPagamento = <Table.Cell  textAlign='right'></Table.Cell>;
                let entrCorrispettivo = '';
                let entrOnereprev = '';
                let entrOnerefisc = '';
                let entrAltroimp = '';
                let entrRitenuta = '';
                let entrPagamento = '';
                let uscCorrispettivo = '';
                let uscOnereprev = '';
                let uscOnerefisc = '';
                let uscAltroimp = '';
                let uscRitenuta = '';
                let uscPagamento = '';
                if (item.entrUsc === 'E'){
                    tabEntrCorrispettivo = <Table.Cell  textAlign='right'><LocalNumber value={item.corrispettivo} type="decimal"/></Table.Cell>
                    tabEntrPagamento = <Table.Cell  textAlign='right'><b><LocalNumber value={item.pagamento} type="decimal"/></b></Table.Cell>
                    entrCorrispettivo = item.corrispettivo;
                    entrOnereprev = item.onereprev;
                    entrOnerefisc = item.onerefisc;
                    entrAltroimp = item.altroimp;
                    entrRitenuta = item.ritenuta;
                    entrPagamento = item.pagamento;
                }
                else {
                    tabUscCorrispettivo = <Table.Cell  textAlign='right'><LocalNumber value={item.corrispettivo} type="decimal"/></Table.Cell>
                    tabUscPagamento = <Table.Cell  textAlign='right'><b><LocalNumber value={item.pagamento} type="decimal"/></b></Table.Cell>
                    uscCorrispettivo = item.corrispettivo;
                    uscOnereprev = item.onereprev;
                    uscOnerefisc = item.onerefisc;
                    uscAltroimp = item.altroimp;
                    uscRitenuta = item.ritenuta;
                    uscPagamento = item.pagamento;
                }

                let rowMovimento = (<Table.Row key={i++}>
                    <Table.Cell>{item.idMovimento}</Table.Cell>
                    <Table.Cell><LocalDate data={item.data}/></Table.Cell>
                    <Table.Cell><LocalDate data={item.dataEmissioneDoc}/></Table.Cell>
                    <Table.Cell textAlign="center">{item.nomeDocumento ? 'x' : ''}</Table.Cell>
                    <Table.Cell>{item.soggetto}</Table.Cell>
                    <Table.Cell>{item.causale}</Table.Cell>
                    {tabEntrCorrispettivo}
                    {tabEntrPagamento}
                    {tabUscCorrispettivo}
                    {tabUscPagamento}
                    <Table.Cell>{item.idCommessa ? item.idCommessa.codice : ''}</Table.Cell>
                    <Table.Cell>{item.idPdc.nomeCompleto}</Table.Cell>
                    <Table.Cell  textAlign='center'>{item.prevDef}</Table.Cell>
                    <Table.Cell  textAlign='center'>{item.annoComp}</Table.Cell>
                    <Table.Cell  textAlign='center'>{item.estrConto}</Table.Cell>
                </Table.Row>)

                let rowMovimentoRaw = {
                    id: item.idMovimento,
                    data: item.data,
                    forma: item.forma ? item.forma : '',
                    soggetto: item.soggetto ? item.soggetto : '',
                    causale: item.causale ? item.causale : '',
                    ecorrispettivo: entrCorrispettivo,
                    eonereprev: entrOnereprev,
                    eonerefisc: entrOnerefisc,
                    ealtroimp: entrAltroimp,
                    eritenuta: entrRitenuta,
                    epagamento: entrPagamento,
                    ucorrispettivo: uscCorrispettivo,
                    uonereprev: uscOnereprev,
                    uonerefisc: uscOnerefisc,
                    ualtroimp: uscAltroimp,
                    uritenuta: uscRitenuta,
                    upagamento: uscPagamento,
                    tipoCassa: item.tipoCassa,
                    commessa:item.idCommessa ? item.idCommessa.codice : '',
                    pdc:item.idPdc.nomeCompleto,
                    pd: item.prevDef ? item.prevDef : '',
                    anno:item.annoComp,
                    ec: item.estrConto ? item.estrConto : '',
                    saldoImp : 0,
                    saldoTot : 0,
                    sottovoce: '',
                    voce: '',
                    categoria: '',
                    dataEmissioneDoc: item.dataEmissioneDoc,
                    documentoAllegato: item.nomeDocumento ? true : false
                }


                let headerCategoria = null;
                let headerVoce = null;
                let headerSottovoce = null;

                if (item.idPdc.catDesc + item.idPdc.voxDesc + item.idPdc.subDesc !== categoria + voce + sottovoce){
                    if (sottovoce !== null){
                        tableRows.push(<Table.Row key={i++}>
                            <Table.Cell colSpan={6} textAlign="right">Entrate/Uscite totali  <b>{sottovoce}:</b></Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["E"].impSottovoce} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].totSottovoce} type="decimal"/></b></Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["U"].impSottovoce} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].totSottovoce} type="decimal"/></b></Table.Cell>
                            <Table.Cell colSpan={5} textAlign="right">Saldo (corr/pag): <LocalNumber value={totali["E"].impSottovoce - totali["U"].impSottovoce} type="decimal"/> / <b><LocalNumber value={totali["E"].totSottovoce - totali["U"].totSottovoce} type="decimal"/></b></Table.Cell>
                        </Table.Row>)
                        rows.push({
                            id: '',
                            data: 'TP',
                            causale: 'Entrate/Uscite totali ' + sottovoce,
                            commessa: totali["E"].impSottovoce - totali["U"].impSottovoce,
                            pd: totali["E"].totSottovoce - totali["U"].totSottovoce,
                            ecorrispettivo: totali["E"].impSottovoce,
                            epagamento: totali["E"].totSottovoce,
                            ucorrispettivo: totali["U"].impSottovoce,
                            upagamento: totali["U"].totSottovoce,
                            saldoImp : totali["E"].impSottovoce - totali["U"].impSottovoce,
                            saldoTot : totali["E"].totSottovoce - totali["U"].totSottovoce,
                            sottovoce: sottovoce,
                            voce: voce,
                            categoria: categoria
                        });
                        totali["E"]["impSottovoce"] = 0;
                        totali["E"]["totSottovoce"] = 0;
                        totali["U"]["impSottovoce"] = 0;
                        totali["U"]["totSottovoce"] = 0;
                    }
                    sottovoce = item.idPdc.subDesc;
                    headerSottovoce = item.idPdc.subDesc;

                }
                if (item.idPdc.catDesc + item.idPdc.voxDesc !== categoria + voce){
                    if (voce !== null){
                        tableRows.push(<Table.Row key={i++}>
                            <Table.Cell colSpan={6} textAlign="right">Entrate/Uscite totali <b>{voce}:</b></Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["E"].impVoce} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].totVoce} type="decimal"/></b></Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["U"].impVoce} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].totVoce} type="decimal"/></b></Table.Cell>
                            <Table.Cell colSpan={5} textAlign="right">Saldo (corr/pag): <LocalNumber value={totali["E"].impVoce - totali["U"].impVoce} type="decimal"/> / <b><LocalNumber value={totali["E"].totVoce - totali["U"].totVoce} type="decimal"/></b></Table.Cell>
                        </Table.Row>)
                        rows.push({
                            id: '',
                            data: 'TP',
                            causale: 'Entrate/Uscite totali ' + voce,
                            commessa: totali["E"].impVoce - totali["U"].impVoce,
                            pd: totali["E"].totVoce - totali["U"].totVoce,
                            ecorrispettivo: totali["E"].impVoce,
                            epagamento: totali["E"].totVoce,
                            ucorrispettivo: totali["U"].impVoce,
                            upagamento: totali["U"].totVoce,
                            saldoImp : totali["E"].impVoce - totali["U"].impVoce,
                            saldoTot : totali["E"].totVoce - totali["U"].totVoce,
                            sottovoce: '',
                            voce: voce,
                            categoria: categoria
                        });

                        totali["E"]["impVoce"] = 0;
                        totali["E"]["totVoce"] = 0;
                        totali["U"]["impVoce"] = 0;
                        totali["U"]["totVoce"] = 0;
                    }
                    voce = item.idPdc.voxDesc;
                    headerVoce = item.idPdc.voxDesc;

                }
                if (item.idPdc.catDesc !== categoria){
                    if (categoria !== null){
                        tableRows.push(<Table.Row key={i++}>
                            <Table.Cell colSpan={6} textAlign="right">Entrate/Uscite totali <b>{categoria}:</b></Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["E"].impCategoria} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].totCategoria} type="decimal"/></b></Table.Cell>
                            <Table.Cell textAlign="right"><LocalNumber value={totali["U"].impCategoria} type="decimal"/></Table.Cell>
                            <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].totCategoria} type="decimal"/></b></Table.Cell>
                            <Table.Cell colSpan={5} textAlign="right">Saldo (corr/pag): <LocalNumber value={totali["E"].impCategoria - totali["U"].impCategoria} type="decimal"/> / <b><LocalNumber value={totali["E"].totCategoria - totali["U"].totCategoria} type="decimal"/></b></Table.Cell>
                        </Table.Row>)
                        rows.push({
                            id: '',
                            data: 'TP',
                            causale: 'Entrate/Uscite totali ' + categoria,
                            commessa: totali["E"].impCategoria - totali["U"].impCategoria,
                            pd: totali["E"].totCategoria - totali["U"].totCategoria,
                            ecorrispettivo: totali["E"].impCategoria,
                            epagamento: totali["E"].totCategoria,
                            ucorrispettivo: totali["U"].impCategoria,
                            upagamento: totali["U"].totCategoria,
                            saldoImp : totali["E"].impCategoria - totali["U"].impCategoria,
                            saldoTot : totali["E"].totCategoria - totali["U"].totCategoria,
                            sottovoce: '',
                            voce: '',
                            categoria: categoria
                        });

                        totali["E"]["impCategoria"] = 0;
                        totali["E"]["totCategoria"] = 0;
                        totali["U"]["impCategoria"] = 0;
                        totali["U"]["totCategoria"] = 0;
                    }

                    categoria = item.idPdc.catDesc;
                    headerCategoria = item.idPdc.catDesc;
                }

                if (headerCategoria){
                    tableRows.push(<Table.Row key={i++}>
                        <Table.Cell className="ui" style={{backgroundColor: "#EEEEEE"}} colSpan={15}><h2>{headerCategoria}</h2></Table.Cell>
                    </Table.Row>);
                    rows.push({
                        id: '',
                        data: 'H1',
                        forma: headerCategoria,
                    });
                }
                if (headerVoce){
                    tableRows.push(<Table.Row key={i++}>
                        <Table.Cell colSpan={15}><h3>&nbsp;{headerVoce}</h3></Table.Cell>
                    </Table.Row>);
                    rows.push({
                        id: '',
                        data: 'H2',
                        forma: headerVoce,
                    });
                }
                if (headerSottovoce){
                    tableRows.push(<Table.Row key={i++}>
                        <Table.Cell colSpan={15}><h3>&nbsp;{headerSottovoce}</h3></Table.Cell>
                    </Table.Row>);
                    rows.push({
                        id: '',
                        data: 'H3',
                        forma: headerSottovoce,
                    });
                }
                tableRows.push(rowMovimento);
                rows.push(rowMovimentoRaw);

                totali[item.entrUsc ]["impCategoria"] += Number.parseFloat(item.corrispettivo);
                totali[item.entrUsc ]["totCategoria"] += Number.parseFloat(item.pagamento);
                totali[item.entrUsc ]["impVoce"] += Number.parseFloat(item.corrispettivo);
                totali[item.entrUsc ]["totVoce"] += Number.parseFloat(item.pagamento);
                totali[item.entrUsc ]["impSottovoce"] += Number.parseFloat(item.corrispettivo);
                totali[item.entrUsc ]["totSottovoce"] += Number.parseFloat(item.pagamento);
                totali[item.entrUsc ]["imp"] += Number.parseFloat(item.corrispettivo);
                totali[item.entrUsc ]["tot"] += Number.parseFloat(item.pagamento);
            });
            tableRows.push(<Table.Row key={i++}>
                <Table.Cell colSpan={6} textAlign="right">Entrate/Uscite totali  <b>{sottovoce}:</b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["E"].impSottovoce} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].totSottovoce} type="decimal"/></b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["U"].impSottovoce} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].totSottovoce} type="decimal"/></b></Table.Cell>
                <Table.Cell colSpan={5} textAlign="right">Saldo (corr/pag): <LocalNumber value={totali["E"].impSottovoce - totali["U"].impSottovoce} type="decimal"/> / <b><LocalNumber value={totali["E"].totSottovoce - totali["U"].totSottovoce} type="decimal"/></b></Table.Cell>
            </Table.Row>)
            rows.push({
                id: '',
                data: 'TP',
                causale: 'Entrate/Uscite totali ' + sottovoce,
                commessa: totali["E"].impSottovoce - totali["U"].impSottovoce,
                pd: totali["E"].totSottovoce - totali["U"].totSottovoce,
                ecorrispettivo: totali["E"].impSottovoce,
                epagamento: totali["E"].totSottovoce,
                ucorrispettivo: totali["U"].impSottovoce,
                upagamento: totali["U"].totSottovoce,
                saldoImp : totali["E"].impSottovoce - totali["U"].impSottovoce,
                saldoTot : totali["E"].totSottovoce - totali["U"].totSottovoce,
                sottovoce: sottovoce,
                voce: voce,
                categoria: categoria
            });
            tableRows.push(<Table.Row key={i++}>
                <Table.Cell colSpan={6} textAlign="right">Entrate/Uscite totali  <b>{voce}:</b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["E"].impVoce} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].totVoce} type="decimal"/></b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["U"].impVoce} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].totVoce} type="decimal"/></b></Table.Cell>
                <Table.Cell colSpan={5} textAlign="right">Saldo (corr/pag): <LocalNumber value={totali["E"].impVoce - totali["U"].impVoce} type="decimal"/> / <b><LocalNumber value={totali["E"].totVoce - totali["U"].totVoce} type="decimal"/></b></Table.Cell>
            </Table.Row>)
            rows.push({
                id: '',
                data: 'TP',
                causale: 'Entrate/Uscite totali ' + voce,
                commessa: totali["E"].impVoce - totali["U"].impVoce,
                pd: totali["E"].totVoce - totali["U"].totVoce,
                ecorrispettivo: totali["E"].impVoce,
                epagamento: totali["E"].totVoce,
                ucorrispettivo: totali["U"].impVoce,
                upagamento: totali["U"].totVoce,
                saldoImp : totali["E"].impVoce - totali["U"].impVoce,
                saldoTot : totali["E"].totVoce - totali["U"].totVoce,
                sottovoce: '',
                voce: voce,
                categoria: categoria
            });
            tableRows.push(<Table.Row key={i++}>
                <Table.Cell colSpan={6} textAlign="right">Entrate/Uscite totali <b>{categoria}:</b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["E"].impCategoria} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].totCategoria} type="decimal"/></b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["U"].impCategoria} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].totCategoria} type="decimal"/></b></Table.Cell>
                <Table.Cell colSpan={5} textAlign="right">Saldo (corr/pag): <LocalNumber value={totali["E"].impCategoria - totali["U"].impCategoria} type="decimal"/> / <b><LocalNumber value={totali["E"].totCategoria - totali["U"].totCategoria} type="decimal"/></b></Table.Cell>
            </Table.Row>)
            rows.push({
                id: '',
                data: 'TP',
                causale: 'Entrate/Uscite totali ' + categoria,
                commessa: totali["E"].impCategoria - totali["U"].impCategoria,
                pd: totali["E"].totCategoria - totali["U"].totCategoria,
                ecorrispettivo: totali["E"].impCategoria,
                epagamento: totali["E"].totCategoria,
                ucorrispettivo: totali["U"].impCategoria,
                upagamento: totali["U"].totCategoria,
                saldoImp : totali["E"].impCategoria - totali["U"].impCategoria,
                saldoTot : totali["E"].totCategoria - totali["U"].totCategoria,
                sottovoce: '',
                voce: '',
                categoria: categoria
            });

            tableRows.push(<Table.Row key={i++}>
                <Table.Cell className="ui" style={{backgroundColor: "#EEEEEE"}} colSpan={15}><h2>Totali generali</h2></Table.Cell>
            </Table.Row>)
            rows.push({
                id: '',
                data: 'H1',
                forma: 'Totali Generali',
            });
            tableRows.push(<Table.Row key={i++}>
                <Table.Cell colSpan={6} textAlign="right"><b>Entrate/Uscite totali </b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["E"].imp} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["E"].tot} type="decimal"/></b></Table.Cell>
                <Table.Cell textAlign="right"><LocalNumber value={totali["U"].imp} type="decimal"/></Table.Cell>
                <Table.Cell textAlign="right"><b><LocalNumber value={totali["U"].tot} type="decimal"/></b></Table.Cell>
                <Table.Cell colSpan={5} textAlign="right">
                    <h4>Totale estratto conto: <LocalNumber value={totali["E"].tot - totali["U"].tot} type="decimal"/></h4>
                </Table.Cell>
            </Table.Row>)
            rows.push({
                id: '',
                data: 'TF',
                causale: 'Entrate/Uscite totali ',
                commessa: totali["E"].imp - totali["U"].imp,
                pd: totali["E"].tot - totali["U"].tot,
                ecorrispettivo: totali["E"].imp,
                epagamento: totali["E"].tot,
                ucorrispettivo: totali["U"].imp,
                upagamento: totali["U"].tot,
                saldoImp : totali["E"].imp - totali["U"].imp,
                saldoTot : totali["E"].tot - totali["U"].tot,
                sottovoce: '',
                voce: '',
                categoria: ''
            });

            if (this.props.onDataCompleted) {
                this.props.onDataCompleted({type:'PDC',title:'Report movimenti per PDC',rows, ultimaModificaInfo});
            }
        }

        this.setState({
            ultimaModificaInfo: ultimaModificaInfo,
            totali: totali,
            rows: rows,
            tableRows: tableRows
        });

    }

    ordinaMovimenti(items){
        items.sort((a,b) => {
            let pdcA = a.idPdc.codiceCompleto.toUpperCase();
            let pdcB = b.idPdc.codiceCompleto.toUpperCase();
            if (pdcA < pdcB) {
                return -1;
            }
            if (pdcA > pdcB) {
                return 1;
            }
            else {
                // Ordina altrimenti per EC e per Data
                let ecA = a.estrConto ? a.estrConto.toUpperCase() : '';
                let ecB = b.estrConto ? b.estrConto.toUpperCase() : '';
                if (ecA < ecB) {
                    return -1;
                }
                if (ecA > ecB) {
                    return 1;
                }
                else {
                    let dtA = a.data;
                    let dtB = b.data;
                    if (dtA < dtB) {
                        return -1;
                    }
                    if (dtA > dtB) {
                        return 1;
                    }
                    else {
                        // Ordina per soggetto
                        let soggA = a.soggetto;
                        let soggB = b.soggetto;
                        if (soggA < soggB) {
                            return -1;
                        }
                        if (soggA > soggB) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    }
                }
            }
        })
    }

    render() {
        let rows = this.state.rows;
        let tableData = null;

        if (rows.length > 0 && this.props.viewData){

            let ultimaModificaText = null;
            if (this.state.ultimaModificaInfo && this.state.ultimaModificaInfo.modificatoDa && this.state.ultimaModificaInfo.modificatoIl){
                ultimaModificaText = <div className="right aligned right floated column">Ultima modifica ai movimenti selezionati eseguita il <LocalDate data={this.state.ultimaModificaInfo.modificatoIl}/> alle ore <LocalTime data={this.state.ultimaModificaInfo.modificatoIl}/> da {this.state.ultimaModificaInfo.modificatoDa.username}</div>
            }

            tableData = (
                <div className="ep-outer-table">
                    <div className="ep-inner-scrollable-table">

                    <Table id="report_movimenti" celled compact={true} className="small">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell textAlign="center" >
                                    Id
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    Data
                                </Table.HeaderCell>
                                <Table.HeaderCell  textAlign="center">
                                    Dt emis. doc.
                                </Table.HeaderCell>
                                <Table.HeaderCell  textAlign="center">
                                    Allegato
                                </Table.HeaderCell>
                                <Table.HeaderCell  textAlign="center">
                                    Soggetto
                                </Table.HeaderCell>
                                <Table.HeaderCell  textAlign="center">
                                    Causale
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" colSpan={2}>
                                    Entrate
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" colSpan={2}>
                                    Uscite
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    Commessa
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    PDC
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    P/D
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    Anno Comp
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    E/C
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell colSpan={6} >

                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    Corrispettivo
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    Pagamento
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    Corrispettivo
                                </Table.HeaderCell>
                                <Table.HeaderCell textAlign="center" >
                                    Pagamento
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={5} >

                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.state.tableRows}
                        </Table.Body>
                        <Table.Footer>
                            <Table.Row>
                            </Table.Row>
                        </Table.Footer>
                    </Table>
                    <div className="ui two columns grid">
                    <div className="column">Stampa eseguita il <LocalDate data={Moment().format("YYYY-MM-DD")}/> alle ore <LocalTime data={Moment().format(Moment().ISO_8601)}/> da {client.getCurrentUser().nome}</div>
                        {ultimaModificaText}
                    </div>
                </div>
                </div>
            )
        }
        else if (this.props.viewData === false){
            tableData = (
                <div className="ui text container">
                    <h3 className="first"><i className="search icon"></i> Nessun dato visualizzato</h3>
                    <p>
                        Se vuoi visualizzare la tabella con i dati, modifica il flag: <b>Mostra Dati<i className="arrow up icon"></i></b>
                    </p>
                </div>
            );
        }
        return tableData
    }
}




export default ReportMovimentiView;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportMovimentiView.js
 **/